exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner[data-v-4a4662de]{\n  background-image: url('https://res.cloudinary.com/dhcti0lrk/image/upload/v1608667711/globalwork/2020-12-22_11-09_mvvpiw.png');\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 186px;\n}\n", ""]);

// exports
